
import 'whatwg-fetch';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


function ServerException(value) {
  this.value = value;
  this.message = "Received an invalid response from the server.";
}

// https://stackoverflow.com/a/25490531
function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

var ProductSource = {
  prequalStart: function (streetAddress, sso_user, coupon_code, referral_code, sonic_elq_customerID, exposure, api_path, return_suggestions) {

    var escapedValue = escapeRegexCharacters(streetAddress.streetAddress.trim());

    // we want to always return a promise from this method
    var emptyPromise = new Promise(function(resolve) {
      resolve([]);
    });


    if (escapedValue === '') {
      return emptyPromise;
    }

    // trim off any leading numbers
    var streetValue = escapedValue.replace(/^\d\s*/, '');

    if(streetValue.length < 3) {
      return emptyPromise;
    }

    var request_body = {
        street_address: streetAddress.streetAddress.trim(),
        secondary: streetAddress.secondary.trim(),
        zip_code: streetAddress.zip.trim(),
        service_type: streetAddress.serviceType,
        sso_user: sso_user,
        coupon_code: coupon_code,
        referral_code: referral_code,
        eloqua_customer_id: sonic_elq_customerID,
        async: true,
        token: ('undefined' !== typeof window.token) ? window.token : '',
        exposure: exposure,
        return_suggestions: return_suggestions,
        smartrfi_lead_source: getCookieValue('smartrfi_lead_source'),
        smartrfi_prospect_id: getCookieValue('smartrfi_prospect_id')
      };

    if(streetAddress.SrvcAddrHousNbr) {
      var att_addr = ['SrvcAddrHousNbr', 'SrvcAddrHousNbrSufx', 'SrvcAddrStDrctl', 'SrvcAddrStName', 'SrvcAddrStThoroughfare', 'LocationDesignator1', 'LocationValue1', 'LocationDesignator2', 'LocationValue2', 'SrvcAddrCity', 'SrvcAddrState', 'SrvcAddrZipCd'].reduce(function(acc, key) {
          if(streetAddress[key]) {
            acc[key] = streetAddress[key]
          }
          return acc;
      }, {});
      request_body = Object.assign({}, request_body, att_addr);  
    }

      var request = new Request(api_path+'?do=prequal_start', {
      method: 'POST', 
      mode: 'cors', 
      redirect: 'follow',
      headers: {
          'Content-Type': 'application/json; charset=UTF-i'
      },
      body: JSON.stringify(request_body)
    });
    return fetch(request)
      .then(function(response) {
        if(!response.ok) {
          throw ServerException(response);
        }

        return response.json();
      })
      .catch(function(ex) {
        return [{error: ex.message}];
      });

  },

  prequalPoll: function (streetAddress, prequal_key, sso_user, coupon_code, sonic_elq_customerID, api_path) {

    var request = new Request(api_path+'?do=prequal_poll', {
      method: 'POST', 
      mode: 'cors', 
      redirect: 'follow',
        headers: {
            'Content-Type': 'application/json; charset=UTF-i'
        },
      body: JSON.stringify({
        street_address: streetAddress.streetAddress.trim(),
        secondary: streetAddress.secondary.trim(),
        zip_code: streetAddress.zip.trim(),
        service_type: streetAddress.serviceType,
        sso_user: sso_user,
        coupon_code: coupon_code,
        eloqua_customer_id: sonic_elq_customerID,
        poll: true,
        async_id: prequal_key,
      })
    });


    return fetch(request)
      .then(function(response) {
        if(!response.ok) {
          throw ServerException(response);
        }
        return response.json();
      })
      .catch(function(ex) {
        return [{error: ex.message}];
      });

  }
}

export default  ProductSource;